import { Star } from "lucide-react";
import { useLanguage } from "@/i18n";
import { Reveal, SectionHeader } from "@/components/Reveal";

const Stars = () => (
  <div className="flex gap-1">
    {[...Array(5)].map((_, i) => (
      <Star key={i} className="w-4 h-4 fill-gold text-gold" strokeWidth={1} />
    ))}
  </div>
);

export const TestimonialsSection = () => {
  const { t } = useLanguage();

  return (
    <section id="avis" className="py-24 sm:py-32 bg-midnight border-y border-hairline/60" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <SectionHeader eyebrow={t.testimonials.eyebrow} title={t.testimonials.title} sub={t.testimonials.sub} />

        <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-5">
          {t.testimonials.items.map((item, i) => (
            <Reveal key={i} delay={0.05 * (i % 5)} className="h-full">
              <figure
                data-testid={`testimonial-card-${i}`}
                className="h-full flex flex-col bg-obsidian border border-hairline rounded-lg p-6 hover:border-gold/40 transition-colors duration-500"
              >
                <Stars />
                <blockquote className="mt-4 flex-1 font-serif italic text-[15px] leading-relaxed text-slate-300">
                  “{item.text}”
                </blockquote>
                <figcaption className="mt-5 pt-4 border-t border-hairline/70">
                  <p className="text-sm font-semibold text-ivory">{item.name}</p>
                  <p className="mt-1 font-mono text-[10px] uppercase tracking-[0.2em] text-gold">{item.location}</p>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
